import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { posthog } from '@/lib/analytics/posthog';
import { consumePendingNotFound } from '@/lib/analytics/notFoundFlag';

// Fire a PostHog $pageview on every React Router navigation. The SPA changes
// the URL client-side without a full load, so PostHog's automatic pageview
// (which only fires on hard navigations) would miss every in-app route change.
// posthog-js no-ops safely if init was skipped (prerender / no token) or the
// visitor opted out, so no extra guard is needed here.
export function usePostHogPageview(): void {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Tag (never drop) 404s: NotFound's useLayoutEffect sets this before this
    // passive effect runs, so unmatched routes stay in the pageview total but
    // can be filtered out of "real content viewed" analysis.
    const is404 = consumePendingNotFound();
    posthog.capture('$pageview', {
      $current_url:
        window.location.origin +
        location.pathname +
        location.search +
        location.hash,
      ...(is404 ? { is_404_page: true } : {}),
    });
  }, [location.pathname, location.search, location.hash]);
}
